import React from 'react';
import {Helmet} from "react-helmet-async";
import {Link} from 'react-router-dom';

const SitemapPage = () => {
    const siteStructure = [
        {
            category: 'Основне',
            links: [
                {title: 'Головна сторінка', path: '/'},
                {title: 'Про нас', path: '/about'},
                {title: 'Контакти', path: '/contacts'},
                {title: 'Дерево посилань', path: '/links'},
            ]
        },
        {
            category: 'Клієнтам',
            links: [
                {title: 'Продажу будинка', path: '/sell-house'},
                {title: 'Оренда Будинку', path: '/rent-house'},
                // {title: 'Дерeв\'яні вироби', path: '/wood-craft'},
            ]
        },
        {
            category: 'Правова інформація',
            links: [
                {title: 'Політика конфіденційності', path: '/legal/privacy-policy'},
                {title: 'Політика Cookie', path: '/legal/cookies-policy'},
                {title: 'Правила користування та проживання', path: '/legal/terms-of-service'},
            ]
        },
        {
            category: 'Соціальні мережі',
            links: [
                {
                    title: 'Instagram (@hlushman_house)',
                    path: 'https://www.instagram.com/hlushman_house/',
                    external: true
                },
                {title: 'Telegram Channel', path: 'https://t.me/userhvv', external: true},
            ]
        }
    ];

    return (
        <>
            <Helmet>
                <title>Мапа сайту — Hlushman House</title>
                <meta name="title" content={"Навігація - Мапа сайту"}/>
                <meta name="description" content="Зручний огляд усіх розділів та сторінок веб-сайту Hlushman House."/>
                <meta property="og:title" content={"Мапа сайту — Hlushman House"}/>
                <meta property="og:description"
                      content="Повний каталог розділів та сторінок сайту. Зручний путівник для швидкого пошуку потрібної інформації."/>
                <meta property="og:image" content="https://hlushman.site/img/logo.jpg"/>
                <meta property="og:url" content={"https:///hlushman.site/sitemap/"}/>
            </Helmet>

            <div className="bg-stone-50 text-stone-800 min-h-screen font-sans">

                {/* Header */}
                <section className="bg-stone-900 text-white py-16 px-6 text-center">
                    <div className="max-w-4xl mx-auto">
                        <span
                            className="text-emerald-400 font-semibold tracking-widest uppercase text-sm">Навігація</span>
                        <h1 className="text-3xl md:text-5xl font-serif font-bold mt-2 mb-4">Мапа сайту</h1>
                        <p className="text-stone-300 max-w-xl mx-auto font-light text-sm md:text-base">
                            Зручний огляд усіх розділів та сторінок веб-сайту Hlushman House.
                        </p>
                    </div>
                </section>

                {/* Main Content */}
                <main className="py-16 px-6 max-w-5xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-8">
                        {siteStructure.map((section, idx) => (
                            <div key={idx} className="bg-white p-8 rounded-2xl border border-stone-200 shadow-sm">
                                <h2 className="text-xl font-serif font-bold text-stone-900 mb-6 flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full bg-emerald-600"/>
                                    {section.category}
                                </h2>
                                <ul className="space-y-3">
                                    {section.links.map((link, linkIdx) => (
                                        <li key={linkIdx}>
                                            <Link
                                                to={link.path}
                                                target={link.external ? '_blank' : '_self'}
                                                rel={link.external ? 'noopener noreferrer' : ''}
                                                className="text-stone-600 hover:text-emerald-700 transition duration-200 flex items-center justify-between group text-base"
                                            >
                                              <span className="group-hover:translate-x-1 transition-transform duration-200">
                                                {link.title}
                                              </span>
                                              {link.external && (<span className="text-xs text-stone-400 group-hover:text-emerald-600">↗</span>)}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </main>

            </div>
        </>
    );
};

export default SitemapPage;